// extracted by mini-css-extract-plugin
export default {"setting_popup":"SettingPopup_setting_popup__lteq7","header":"SettingPopup_header__mtZq4","cancel":"SettingPopup_cancel__kGMBu","save":"SettingPopup_save__jZuD1"};